"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[570],{

/***/ 9296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ItemNotFound; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



function ItemNotFound() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
        h: "50vh",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
            children: locale == "id" ? "Tidak Ditemukan." : "Not Found."
        })
    });
};


/***/ }),

/***/ 570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SectionView; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/index.mjs + 808 modules
var dist = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var index_esm = __webpack_require__(155);
// EXTERNAL MODULE: ./src/layout/Section.jsx
var Section = __webpack_require__(1914);
// EXTERNAL MODULE: ./src/utils/mediaQuery.js
var mediaQuery = __webpack_require__(9741);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/ItemGrid.jsx




function ItemGrid(param) {
    var id = param.id, thumb = param.thumb, title = param.title, desc = param.desc, _buttonType = param.buttonType, buttonType = _buttonType === void 0 ? "outline" : _buttonType, _color = param.color, color = _color === void 0 ? "black" : _color, _target = param.target, target = _target === void 0 ? "" : _target, _hasAdditionalInfo = param.hasAdditionalInfo, hasAdditionalInfo = _hasAdditionalInfo === void 0 ? false : _hasAdditionalInfo;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
        direction: "column",
        w: "100%",
        justify: "space-between",
        gap: 4,
        letterSpacing: "wide",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                direction: "column",
                gap: 4,
                color: "blackAlpha.700",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                        h: "60vh",
                        w: "100%",
                        position: "relative",
                        cursor: "pointer",
                        onClick: function() {
                            return router.push(target);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "fill",
                            alt: "",
                            src: thumb,
                            objectFit: "cover",
                            priority: true,
                            unoptimized: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                        as: "h2",
                        fontWeight: 400,
                        fontSize: "xl",
                        letterSpacing: 4,
                        color: "black",
                        mt: 3,
                        className: "max-text-1-line",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                        fontSize: "sm",
                        letterSpacing: 0.2,
                        lineHeight: 1.2,
                        noOfLines: 2,
                        children: desc
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                gap: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                    variant: "outlineWhite",
                    color: color,
                    borderColor: color,
                    _hover: {
                        bg: color,
                        color: "white"
                    },
                    onClick: function() {
                        return router.push(target);
                    },
                    children: router.locale == "id" ? "Lebih Lengkap" : "See More"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(9583);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
;// CONCATENATED MODULE: ./src/components/ItemGridHotel.tsx






function ItemGridHotel(param) {
    var id = param.id, thumb = param.thumb, title = param.title, desc = param.desc, _color = param.color, color = _color === void 0 ? "black" : _color, _benefits = param.benefits, benefits = _benefits === void 0 ? [] : _benefits, _price = param.price, price = _price === void 0 ? 0 : _price, slug = param.slug;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
        direction: "column",
        w: "100%",
        justify: "space-between",
        gap: 3,
        letterSpacing: "wide",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                        direction: "column",
                        gap: 1,
                        color: "blackAlpha.700",
                        justify: "s",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                h: "60vh",
                                w: "100%",
                                position: "relative",
                                bg: "gray.300",
                                onClick: function() {
                                    return router.push("/".concat(slug));
                                },
                                cursor: "pointer",
                                children: thumb && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    layout: "fill",
                                    alt: "",
                                    src: thumb,
                                    objectFit: "cover",
                                    priority: true,
                                    unoptimized: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                                as: "h2",
                                fontWeight: 400,
                                fontSize: "xl",
                                letterSpacing: 4,
                                color: "black",
                                mt: 5,
                                className: "max-text-1-line",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Text */.xvT, {
                                fontSize: "sm",
                                mt: 2,
                                children: [
                                    router.locale == "id" ? "Harga mulai" : "Start from",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: price ? (0,functions/* formatRupiah */.b7)(price) : "[price]"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                        mt: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                            orientation: "horizontal",
                            borderColor: "blackAlpha.400"
                        })
                    })
                ]
            }),
            benefits.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                align: "center",
                color: "blackAlpha.700",
                rowGap: 1,
                columnGap: 6,
                flexWrap: "wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                        align: "center",
                        fontSize: "small",
                        gap: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaMapMarkerAlt */.Nh4, {
                                color: "inherit",
                                size: 12
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                children: benefits[0]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                        align: "center",
                        fontSize: "small",
                        gap: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaPhoneAlt */.DNl, {
                                color: "inherit",
                                size: 12
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                children: benefits[1]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                        align: "center",
                        fontSize: "small",
                        gap: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaEnvelope */.SRX, {
                                color: "inherit",
                                size: 12
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                children: benefits[2]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                gap: 4,
                mt: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                    variant: "outlineWhite",
                    color: color,
                    _hover: {
                        bg: color,
                        color: "white"
                    },
                    borderColor: color,
                    onClick: function() {
                        return router.push("/".concat(slug));
                    },
                    children: router.locale == "id" ? "Lebih Lengkap" : "See More"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/ItemGridMeeting.jsx





function ItemGridMeeting(param) {
    var id = param.id, thumb = param.thumb, title = param.title, desc = param.desc, _buttonType = param.buttonType, buttonType = _buttonType === void 0 ? "outline" : _buttonType, _color = param.color, color = _color === void 0 ? "black" : _color, _target = param.target, target = _target === void 0 ? "" : _target, _benefits = param.benefits, benefits = _benefits === void 0 ? [] : _benefits, category = param.category;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
        direction: "column",
        w: "100%",
        justify: "space-between",
        gap: 4,
        letterSpacing: "wide",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                    direction: "column",
                    gap: 1,
                    color: "blackAlpha.700",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                            h: "60vh",
                            w: "100%",
                            position: "relative",
                            cursor: "pointer",
                            onClick: function() {
                                return router.push(target);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                layout: "fill",
                                alt: "",
                                src: thumb,
                                objectFit: "cover",
                                priority: true,
                                unoptimized: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                            as: "h2",
                            fontWeight: 400,
                            fontSize: "xl",
                            letterSpacing: 4,
                            color: "black",
                            className: "max-text-1-line",
                            mt: 5,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                            fontSize: "sm",
                            letterSpacing: 0.2,
                            lineHeight: 1.2,
                            my: 2,
                            noOfLines: 2,
                            children: desc
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                flexDir: "column",
                gap: 4,
                children: [
                    category !== "Social Events" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                    orientation: "horizontal",
                                    borderColor: "blackAlpha.400"
                                })
                            }),
                            benefits.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                align: "center",
                                color: "blackAlpha.700",
                                gap: 6,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                        align: "center",
                                        fontSize: "small",
                                        gap: 2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaUser */.Xws, {
                                                color: "inherit",
                                                size: 12
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                                children: benefits[0]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                        align: "center",
                                        fontSize: "small",
                                        gap: 2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaRulerCombined */.aVx, {
                                                color: "inherit",
                                                size: 12
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Text */.xvT, {
                                                children: [
                                                    benefits[1],
                                                    " m\xb2"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                        gap: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                            variant: "outlineWhite",
                            color: color,
                            _hover: {
                                bg: color,
                                color: "white"
                            },
                            borderColor: color,
                            onClick: function() {
                                return router.push(target);
                            },
                            children: router.locale == "id" ? "Lebih Lengkap" : "See More"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/ItemGridRoom.jsx






function ItemGridRoom(param) {
    var id = param.id, thumb = param.thumb, title = param.title, desc = param.desc, _buttonType = param.buttonType, buttonType = _buttonType === void 0 ? "outline" : _buttonType, _color = param.color, color = _color === void 0 ? "black" : _color, _target = param.target, target = _target === void 0 ? "" : _target, _benefits = param.benefits, benefits = _benefits === void 0 ? [] : _benefits, _price = param.price, price = _price === void 0 ? 0 : _price;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
        direction: "column",
        w: "100%",
        justify: "space-between",
        gap: 4,
        letterSpacing: "wide",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                direction: "column",
                gap: 1,
                color: "blackAlpha.700",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                        h: [
                            "30vh",
                            null,
                            null,
                            "42vh"
                        ],
                        w: "100%",
                        position: "relative",
                        onClick: function() {
                            return router.push(target);
                        },
                        cursor: "pointer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "fill",
                            alt: "",
                            src: thumb,
                            objectFit: "cover",
                            priority: true,
                            unoptimized: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                        as: "h2",
                        fontWeight: 400,
                        fontSize: "xl",
                        letterSpacing: 4,
                        color: "black",
                        className: "max-text-1-line",
                        mt: 5,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                        fontSize: "sm",
                        display: "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: price ? (0,functions/* formatRupiah */.b7)(price) : "[price]"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                        fontSize: "sm",
                        letterSpacing: 0.2,
                        lineHeight: 1.2,
                        my: 2,
                        noOfLines: 2,
                        children: desc
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                    orientation: "horizontal",
                    borderColor: "blackAlpha.400"
                })
            }),
            benefits.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                align: "center",
                color: "blackAlpha.700",
                gap: 6,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                        align: "center",
                        fontSize: "small",
                        gap: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaUser */.Xws, {
                                color: "inherit",
                                size: 12
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                noOfLines: 1,
                                children: benefits[0]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                        align: "center",
                        fontSize: "small",
                        gap: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaBed */.f0S, {
                                color: "inherit",
                                size: 16
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                noOfLines: 1,
                                children: benefits[1]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                        align: "center",
                        fontSize: "small",
                        gap: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaRulerCombined */.aVx, {
                                color: "inherit",
                                size: 12
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Text */.xvT, {
                                noOfLines: 1,
                                whiteSpace: "nowrap",
                                children: [
                                    benefits[2],
                                    " m\xb2"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                gap: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                    variant: "outlineWhite",
                    color: color,
                    borderColor: color,
                    _hover: {
                        bg: color,
                        color: "white"
                    },
                    onClick: function() {
                        return router.push(target);
                    },
                    children: router.locale == "id" ? "Lebih Lengkap" : "See More"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/ItemList.jsx




function ItemList(param) {
    var id = param.id, thumb = param.thumb, title = param.title, desc = param.desc, _buttonType = param.buttonType, buttonType = _buttonType === void 0 ? "outline" : _buttonType, _color = param.color, color = _color === void 0 ? "black" : _color, _target = param.target, target = _target === void 0 ? "" : _target;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
        h: "100%",
        w: "100%",
        gap: 10,
        letterSpacing: "wide",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                h: "60vh",
                w: "65%",
                position: "relative",
                cursor: "pointer",
                onClick: function() {
                    return router.push(target);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "fill",
                    alt: "",
                    src: thumb,
                    objectFit: "cover",
                    priority: true,
                    unoptimized: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                w: "35%",
                align: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                    direction: "column",
                    gap: 4,
                    color: "blackAlpha.700",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                            as: "h2",
                            fontWeight: 400,
                            fontSize: "xl",
                            letterSpacing: 4,
                            color: "black",
                            mt: 3,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                            fontSize: "sm",
                            letterSpacing: 0.2,
                            lineHeight: 1.2,
                            children: desc
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                            gap: 4,
                            mt: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                                variant: "outlineWhite",
                                color: color,
                                _hover: {
                                    bg: color,
                                    color: "white"
                                },
                                borderColor: color,
                                onClick: function() {
                                    return router.push(target);
                                },
                                children: router.locale == "id" ? "Lebih Lengkap" : "See More"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/ItemListHotel.tsx






function ItemListHotel(param) {
    var id = param.id, thumb = param.thumb, title = param.title, desc = param.desc, _color = param.color, color = _color === void 0 ? "black" : _color, _benefits = param.benefits, benefits = _benefits === void 0 ? [] : _benefits, _price = param.price, price = _price === void 0 ? 0 : _price, slug = param.slug;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
        h: "100%",
        w: "100%",
        gap: 10,
        letterSpacing: "wide",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                h: "60vh",
                w: "65%",
                position: "relative",
                cursor: "pointer",
                onClick: function() {
                    return router.push("/".concat(slug));
                },
                children: thumb && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "fill",
                    alt: "",
                    src: thumb,
                    objectFit: "cover",
                    priority: true,
                    unoptimized: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                w: "35%",
                align: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                    direction: "column",
                    gap: 4,
                    color: "blackAlpha.700",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                            as: "h2",
                            fontWeight: 400,
                            fontSize: "xl",
                            letterSpacing: 4,
                            color: "black",
                            mt: 3,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Text */.xvT, {
                            fontSize: "sm",
                            mt: 2,
                            children: [
                                router.locale == "id" ? "Harga mulai" : "Start from",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: price ? (0,functions/* formatRupiah */.b7)(price) : "[price]"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                orientation: "horizontal",
                                borderColor: "blackAlpha.400"
                            })
                        }),
                        benefits.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                            align: "center",
                            color: "blackAlpha.700",
                            rowGap: 1,
                            columnGap: 6,
                            flexWrap: "wrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                    align: "center",
                                    fontSize: "small",
                                    gap: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaMapMarkerAlt */.Nh4, {
                                            color: "inherit",
                                            size: 12
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                            children: benefits[0]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                    align: "center",
                                    fontSize: "small",
                                    gap: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaPhoneAlt */.DNl, {
                                            color: "inherit",
                                            size: 12
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                            children: benefits[1]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                    align: "center",
                                    fontSize: "small",
                                    gap: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaEnvelope */.SRX, {
                                            color: "inherit",
                                            size: 12
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                            children: benefits[2]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                            gap: 4,
                            mt: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                                variant: "outlineWhite",
                                color: color,
                                _hover: {
                                    bg: color,
                                    color: "white"
                                },
                                borderColor: color,
                                onClick: function() {
                                    return router.push("/".concat(slug));
                                },
                                children: router.locale == "id" ? "Lebih Lengkap" : "See More"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/ItemListMeeting.jsx





function ItemListMeeting(param) {
    var id = param.id, thumb = param.thumb, title = param.title, desc = param.desc, _buttonType = param.buttonType, buttonType = _buttonType === void 0 ? "outline" : _buttonType, _color = param.color, color = _color === void 0 ? "black" : _color, _target = param.target, target = _target === void 0 ? "" : _target, _benefits = param.benefits, benefits = _benefits === void 0 ? [] : _benefits, category = param.category;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
        h: "100%",
        w: "100%",
        gap: 10,
        letterSpacing: "wide",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                h: "60vh",
                w: "65%",
                position: "relative",
                cursor: "pointer",
                onClick: function() {
                    return router.push(target);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "fill",
                    alt: "",
                    src: thumb,
                    objectFit: "cover",
                    priority: true,
                    unoptimized: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                w: "35%",
                align: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                    direction: "column",
                    gap: 4,
                    color: "blackAlpha.700",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                            as: "h2",
                            fontWeight: 400,
                            fontSize: "xl",
                            letterSpacing: 4,
                            color: "black",
                            mt: 3,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                            fontSize: "sm",
                            letterSpacing: 0.2,
                            lineHeight: 1.2,
                            children: desc
                        }),
                        category !== "Social Events" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                        orientation: "horizontal",
                                        borderColor: "blackAlpha.400"
                                    })
                                }),
                                benefits.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                    align: "center",
                                    color: "blackAlpha.700",
                                    gap: 6,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                            align: "center",
                                            fontSize: "small",
                                            gap: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaUser */.Xws, {
                                                    color: "inherit",
                                                    size: 12
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                                    children: benefits[0]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                            align: "center",
                                            fontSize: "small",
                                            gap: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaRulerCombined */.aVx, {
                                                    color: "inherit",
                                                    size: 12
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Text */.xvT, {
                                                    children: [
                                                        benefits[1],
                                                        " m\xb2"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                            gap: 4,
                            mt: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                                variant: "outlineWhite",
                                color: color,
                                _hover: {
                                    bg: color,
                                    color: "white"
                                },
                                borderColor: color,
                                onClick: function() {
                                    return router.push(target);
                                },
                                children: router.locale == "id" ? "Lebih Lengkap" : "See More"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/ItemListRoom.jsx






function ItemListRoom(param) {
    var id = param.id, thumb = param.thumb, title = param.title, desc = param.desc, _buttonType = param.buttonType, buttonType = _buttonType === void 0 ? "outline" : _buttonType, _color = param.color, color = _color === void 0 ? "black" : _color, _target = param.target, target = _target === void 0 ? "" : _target, _benefits = param.benefits, benefits = _benefits === void 0 ? [] : _benefits, _price = param.price, price = _price === void 0 ? 0 : _price;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
        h: "100%",
        w: "100%",
        gap: 10,
        letterSpacing: "wide",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                h: "60vh",
                w: "65%",
                position: "relative",
                cursor: "pointer",
                onClick: function() {
                    return router.push(target);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "fill",
                    alt: "",
                    src: thumb,
                    objectFit: "cover",
                    priority: true,
                    unoptimized: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                w: "35%",
                align: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                    direction: "column",
                    gap: 4,
                    color: "blackAlpha.700",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                            as: "h2",
                            fontWeight: 400,
                            fontSize: "xl",
                            letterSpacing: 4,
                            color: "black",
                            mt: 3,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                            fontSize: "sm",
                            mb: 2,
                            display: "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: price ? (0,functions/* formatRupiah */.b7)(price) : "[price]"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                            fontSize: "sm",
                            letterSpacing: 0.2,
                            lineHeight: 1.2,
                            children: desc
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                orientation: "horizontal",
                                borderColor: "blackAlpha.400"
                            })
                        }),
                        benefits.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                            align: "center",
                            color: "blackAlpha.700",
                            gap: 6,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                    align: "center",
                                    fontSize: "small",
                                    gap: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaUser */.Xws, {
                                            color: "inherit",
                                            size: 12
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                            children: benefits[0]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                    align: "center",
                                    fontSize: "small",
                                    gap: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaBed */.f0S, {
                                            color: "inherit",
                                            size: 16
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                            children: benefits[1]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                    align: "center",
                                    fontSize: "small",
                                    gap: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaRulerCombined */.aVx, {
                                            color: "inherit",
                                            size: 12
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Text */.xvT, {
                                            children: [
                                                benefits[2],
                                                " m\xb2"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                            gap: 4,
                            mt: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                                variant: "outlineWhite",
                                color: color,
                                _hover: {
                                    bg: color,
                                    color: "white"
                                },
                                borderColor: color,
                                onClick: function() {
                                    return router.push(target);
                                },
                                children: router.locale == "id" ? "Lebih Lengkap" : "See More"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/ItemNotFound.tsx
var ItemNotFound = __webpack_require__(9296);
;// CONCATENATED MODULE: ./src/components/SectionView.jsx

















function SectionView(param) {
    var _title = param.title, title = _title === void 0 ? "" : _title, _enableFilter = param.enableFilter, enableFilter = _enableFilter === void 0 ? false : _enableFilter, _view = param.view, view = _view === void 0 ? "grid" : _view, _items = param.items, items = _items === void 0 ? [] : _items, _color = param.color, color = _color === void 0 ? "black" : _color, _targetItems = param.targetItems, targetItems = _targetItems === void 0 ? [] : _targetItems, _type = param.type, type = _type === void 0 ? "default" : _type, _hasCategory = param.hasCategory, hasCategory = _hasCategory === void 0 ? false : _hasCategory, _categories = param.categories, categories = _categories === void 0 ? [] : _categories, _isManualTarget = param.isManualTarget, isManualTarget = _isManualTarget === void 0 ? false : _isManualTarget, _defaultCategory = param.defaultCategory, defaultCategory = _defaultCategory === void 0 ? "all" : _defaultCategory;
    var ref = (0,next_router.useRouter)(), isReady = ref.isReady, query = ref.query, locale = ref.locale;
    var isLarge = (0,mediaQuery/* useLargeQuery */.fc)().isLarge;
    var ref1 = (0,react.useState)(categories.length > 0 ? defaultCategory : null), selectedCategory = ref1[0], setSelectedCategory = ref1[1];
    var ref2 = (0,react.useState)(hasCategory ? [] : items), selectedItems = ref2[0], setSelectedItems = ref2[1];
    var ref3 = (0,react.useState)(type), selectedType = ref3[0], setSelectedType = ref3[1];
    var ref4 = (0,react.useState)(hasCategory ? "grid" : items.length > 2 || !isLarge ? "grid" : "list"), viewAs = ref4[0], setViewAs = ref4[1];
    (0,react.useEffect)(function() {
        if (!hasCategory) return;
        if (selectedCategory == categories[0]) {
            var temp = (0,lodash.reject)(items, {
                category: "Venue"
            });
            setSelectedItems(temp);
        } else {
            var temp1 = (0,lodash.filter)(items, {
                category: selectedCategory
            });
            setSelectedItems(temp1);
        }
    }, [
        selectedCategory,
        isReady
    ]);
    (0,react.useEffect)(function() {
        if (!hasCategory) return;
        setViewAs(selectedItems.length > 2 || !isLarge ? "grid" : "list");
    }, [
        selectedItems,
        selectedCategory,
        isLarge
    ]);
    (0,react.useEffect)(function() {
        if (!hasCategory) {
            setSelectedItems(items);
            setViewAs(items.length > 2 || !isLarge ? "grid" : "list");
        }
    }, [
        isReady,
        items,
        isLarge
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
        bg: "white",
        variant: "zero",
        px: mediaQuery/* safeMarginX */.Mp,
        mt: 5,
        mb: mediaQuery/* safeMarginDesc */.nb,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                justify: "space-between",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                        mb: 2,
                        as: "h1",
                        fontWeight: 400,
                        letterSpacing: "wider",
                        color: color,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                        align: "center",
                        color: "blackAlpha.600",
                        gap: 4,
                        children: [
                            isLarge && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                        onClick: function() {
                                            return setViewAs("list");
                                        },
                                        cursor: "pointer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoListOutline */.mKE, {
                                            color: viewAs === "list" ? color : "inherit",
                                            size: 28
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                        onClick: function() {
                                            return setViewAs("grid");
                                        },
                                        cursor: "pointer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoGridOutline */.zrF, {
                                            color: viewAs === "grid" ? color : "inherit",
                                            size: 22
                                        })
                                    })
                                ]
                            }),
                            enableFilter && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                        h: "20px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                            borderColor: "blackAlpha.500",
                                            opacity: 1,
                                            orientation: "vertical"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Select */.PhF, {
                                        fontSize: "sm",
                                        border: "none",
                                        _focus: {},
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            children: locale == "id" ? "TERBARU" : "LATEST"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            hasCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                gap: [
                    4,
                    6,
                    8,
                    10
                ],
                mb: 2,
                children: categories.map(function(cat) {
                    var isSelected = cat === selectedCategory;
                    var showCat;
                    if (locale == "id") {
                        if (cat == "all") showCat = "semua";
                        if (cat == "Meeting Package") showCat = "Paket Rapat";
                        if (cat == "Social Events") showCat = "Acara Sosial";
                        if (cat == "Venue") showCat = "Venue";
                    } else {
                        showCat = cat;
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                        textTransform: "uppercase",
                        fontSize: [
                            "small",
                            "md",
                            "lg",
                            "2xl"
                        ],
                        fontWeight: isSelected ? 500 : 400,
                        cursor: "pointer",
                        color: isSelected ? "blackAlpha.900" : "blackAlpha.600",
                        textDecoration: isSelected ? "underline" : "none",
                        _hover: {
                            textDecoration: "underline"
                        },
                        onClick: function() {
                            setSelectedCategory(cat);
                        },
                        children: showCat
                    }, cat);
                })
            }),
            selectedItems.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    viewAs === "grid" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SimpleGrid */.MIq, {
                        columns: [
                            1,
                            1,
                            2,
                            2,
                            3
                        ],
                        spacing: [
                            12,
                            10,
                            8
                        ],
                        children: selectedItems.map(function(item, i) {
                            if (type == "default") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemGrid, {
                                thumb: item.thumb,
                                title: item.title,
                                desc: item.desc,
                                id: item._ID,
                                color: color,
                                target: targetItems[i]
                            }, i);
                            else if (type == "rooms") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemGridRoom, {
                                thumb: item.thumb,
                                title: item.title,
                                desc: item.desc,
                                id: item._ID,
                                color: color,
                                target: targetItems[i],
                                benefits: [
                                    item.total_guest,
                                    item.bed_type,
                                    item.room_size, 
                                ],
                                price: item.start_from
                            }, i);
                            else if (type == "meeting") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemGridMeeting, {
                                thumb: item.thumb,
                                title: item.title,
                                desc: item.desc,
                                id: item._ID,
                                color: color,
                                target: "/".concat(query.hid, "/meeting-events/detail?id=").concat(item._ID),
                                benefits: [
                                    item.total_person,
                                    item.room_size
                                ],
                                category: item.category
                            }, i);
                            else if (type == "hotels") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemGridHotel, {
                                thumb: item.thumb,
                                title: item.title,
                                id: item._ID,
                                color: color,
                                benefits: [
                                    item.location,
                                    item.phone,
                                    item.email
                                ],
                                price: item.start_from,
                                slug: item.slug
                            }, i);
                        })
                    }),
                    viewAs === "list" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                        direction: "column",
                        gap: [
                            6,
                            12
                        ],
                        children: selectedItems.map(function(item, i) {
                            if (type == "default") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemList, {
                                thumb: item.thumb,
                                title: item.title,
                                desc: item.desc,
                                id: item._ID,
                                color: color,
                                target: targetItems[i]
                            }, i);
                            else if (type == "rooms") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemListRoom, {
                                thumb: item.thumb,
                                title: item.title,
                                desc: item.desc,
                                id: item._ID,
                                color: color,
                                target: targetItems[i],
                                benefits: [
                                    item.total_guest,
                                    item.bed_type,
                                    item.room_size, 
                                ],
                                price: item.start_from
                            }, i);
                            else if (type == "meeting") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemListMeeting, {
                                thumb: item.thumb,
                                title: item.title,
                                desc: item.desc,
                                id: item._ID,
                                color: color,
                                target: "/".concat(query.hid, "/meeting-events/detail?id=").concat(item._ID),
                                benefits: [
                                    item.total_person,
                                    item.room_size
                                ],
                                category: item.category
                            }, i);
                            else if (type == "hotels") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemListHotel, {
                                thumb: item.thumb,
                                title: item.title,
                                id: item._ID,
                                color: color,
                                benefits: [
                                    item.location,
                                    item.phone,
                                    item.email
                                ],
                                price: item.start_from,
                                slug: item.slug
                            }, i);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemNotFound/* default */.Z, {})
        ]
    });
};


/***/ })

}]);